<template>
  <div class="title-bar-card" :style="styles">
    <p class="title-text">{{ data.title }}</p>
    <p class="title-description">{{ data.description }}</p>

    <span
      v-if="data.data && data.type"
      class="more"
      @click="$cmsStoreJump(
          data.type,
          data.data,
          {
            storeId,
            source: cmsSource
          }
        )"
    >
      More&nbsp;<van-icon name="arrow" />
    </span>
  </div>
</template>

<script setup lang="ts">
import type { StyleValue } from 'vue'
import { buildStoreHomeListingSource, resolveStoreHomeSourceValue } from '@/plugins/utils'

const props = defineProps<{ storeId: number, data: IStore.ITtile }>()
const route = useRoute()

const cmsSource = computed(() =>
  buildStoreHomeListingSource(
    resolveStoreHomeSourceValue('title', { title: props.data.title }),
    undefined,
    route
  )
)

const styles = computed<StyleValue>(() => {
  const { position, background, font_color } = props.data
  return {
    textAlign: position,
    background: background,
    color: font_color
  }
})
</script>

<style lang="scss" scoped>
.title-bar-card{
  position: relative;
  padding: 10px 30px;
}
.more{
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0 20px;
  height: 100%;
  padding-top: 10px;
}
.title-text{ font-size: 26px; text-shadow: 1px 1px; }
.title-description{ font-size: 22px;margin-top: 15px; }
</style>